// @flow

import * as React from 'react';
import { Panel } from 'react-bootstrap';
import api from '../../../api'

type Props = {
  left: string,
  title: string,
  hidden: boolean,
  center: boolean
};
 api.paypal.getVersion().then(response => {
    if (!response) {
      localStorage.setItem("ppv","1")
    }else{
      localStorage.setItem("ppv",response.version)
    }
});
const PanelHeading = (props: Props) => {
  return (
    <Panel.Heading className={ props.hidden && 'hidden' }        >
      <Panel.Title className="panel-title container">
          <h3 className={ props.center && 'centered' } >{props.title}</h3>
      </Panel.Title>
    </Panel.Heading>
  );
};

export default PanelHeading;



// WEBPACK FOOTER //
// ./src/containers/QuotePage/PanelHeading/index.js